import { FREETEXT_KEYS } from '~/const/freetext';
import { LOGIN_ERROR_KEY } from '~/const/login';
import { getStore } from '~/mobx/AppStore';

const getErrorTitleMessage = () => {
    const { ballotStore, freetextStore } = getStore();
    const loginError = ballotStore.loginError;
    if (loginError === undefined) {
        return undefined;
    }

    switch (loginError) {
        case LOGIN_ERROR_KEY.unauthorized:
            return freetextStore.getFreetextValueByKey(FREETEXT_KEYS.login_error_unauthorized);
        case LOGIN_ERROR_KEY.no_valid_membership:
            return undefined;
        default:
            return freetextStore.getFreetextValueByKey(FREETEXT_KEYS.login_error_access_denied);
    }
};

export default getErrorTitleMessage;
